import ToggleSwitch from '@components/ToggleSwitch'

const EnableOnDemandAccessService = ({ checked, onChange }) => (
    <div>
        <div className="d-flex justify-content-between align-items-center">
            <h3 className="font-weight-bold">
                <T>dashboard.on.demand.parking.enable.service.title</T>
            </h3>
            <ToggleSwitch
                id="on-demand-access-service"
                checked={checked}
                onChange={onChange}
                className="d-flex justify-content-end"
            />
        </div>
        <div className="mt-2">
            <p className="text-large">
                <T>dashboard.on.demand.parking.enable.service.description</T>
            </p>
        </div>
    </div>
)

export default EnableOnDemandAccessService
